
import tableSponsor from './tableSponsor';

export default {
  title: 'Sponsors',
  attributeName: 'sponsors',
  getURL: 'sponsors',
  // updateURL: 'liveStatus',
  removeURL: 'sponsors',
  sessionParams: [],
  noArea: true,
  tableConfig: tableSponsor,
  // sessionWebsocketParams: [],
  autoUpdate: true,
  // websocketNavigation:'users_navigation',
};
